import { ServiceHelper2 } from "../../Common/_helpers/ServiceHelper2";
import { BUDGETS_API_URLS } from "../_constants/url.constants";

export const LicensesService = {
    listLicenses,
    assignLicense,
    assignLicenseBulk,
    getAdminLocations,
    renewLicense,
    cancelLicense,
    reactivateLicense,
};

async function listLicenses() {
    return await ServiceHelper2.getRequest(
        BUDGETS_API_URLS.LICENSES,
    );
}

async function assignLicense({
    locationID,
    email,
    licenseTypeUID,
    quantity,
    createVirtualClockin = false,
}) {
    return await ServiceHelper2.postRequest(
        BUDGETS_API_URLS.LICENSE_ASSIGN,
        {
            location_id: locationID,
            email: email,
            license_type_uid: licenseTypeUID,
            quantity: quantity,
            create_virtual_clockin: createVirtualClockin,
        },
    );
}

async function renewLicense({
    uid
}) {
    return await ServiceHelper2.postRequest(
        BUDGETS_API_URLS.LICENSE_RENEW,
        {
            uid: uid,
        },
    );
}

async function cancelLicense({
    uid
}) {
    return await ServiceHelper2.postRequest(
        BUDGETS_API_URLS.LICENSE_CANCEL,
        {
            uid: uid,
        },
    );
}

async function reactivateLicense({
    uid
}) {
    return await ServiceHelper2.postRequest(
        BUDGETS_API_URLS.LICENSE_REACTIVATE,
        {
            uid: uid,
        },
    );
}

async function getAdminLocations(email) {
    return await ServiceHelper2.getRequest(
        BUDGETS_API_URLS.DISTRIBUTOR_ADMIN_LOCATIONS + "?email=" + encodeURIComponent(email),
    );
}

async function assignLicenseBulk({
    email,
    licenseTypeUID,
    quantity,
    locationIds,
    createVirtualClockin = false,
}) {
    return await ServiceHelper2.postRequest(
        BUDGETS_API_URLS.LICENSE_ASSIGN_BULK,
        {
            email: email,
            license_type_uid: licenseTypeUID,
            quantity: quantity,
            location_ids: locationIds,
            create_virtual_clockin: createVirtualClockin,
        },
    );
}
